import React, { Component } from "react";
import { mensajeExito } from "../../../generico/MensajeSistemaToast"
import DataTable from 'react-data-table-component';
import history from "../../login/history"
import DatosSocio from "../../../generico/DatosSocio"
import DebitoAutomaticoService from "../../../../services/autogestion/DebitoAutomaticoService";
import { trackPromise } from 'react-promise-tracker';
import AuthService from "../../../../services/login/auth.service";
import authService from "../../../../services/login/auth.service";
import ConfigService from "../../../../services/configuracion/ConfigService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faFilePdf, faArrowUp} from "@fortawesome/free-solid-svg-icons";

export default class AgregarPaso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    this.tipo="";
    this.identificador=""
    this.montoPorcentaje = "";
  }

  getInitialState = () => ({
    datosCuenta: undefined
  })

  componentDidMount() {
  
  }

  

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }

  getDatosPrestamo() {
    if (this.props.rptPaso1.nroModalidad === "10") {
      var porcentaje = "100% de la deuda (Saldo Cierre)"
      if(this.props.rptPaso1.TC_porcentaje === "5")
      porcentaje = "5% de la deuda (Pago Mínimo)"
      var respuesta = [
        { concepto: "Modalidad:", valor: this.props.rptPaso1.modalidad },
        { concepto: "Cuenta a Debitar:", valor: this.props.rptPaso1.cuenta_debito },
        { concepto: "Cuenta a Acreditar:", valor: this.props.rptPaso1.TC_tarjeta +" - "+ this.props.rptPaso1.TC_tipo},
        { concepto: "Importe a Debitar:", valor: porcentaje }
      ];

      this.setState({ datosCuenta: respuesta });
    }
    if (this.props.rptPaso1.nroModalidad !== "10"){
      var respuesta = [
        { concepto: "Modalidad:", valor: this.props.rptPaso1.modalidad },
        { concepto: "Cuenta a Debitar:", valor: this.props.rptPaso1.cuenta_debito },
        { concepto: "Cuenta a Acreditar:", valor: this.props.rptPaso1.cuenta_credito }
      ];

      this.setState({ datosCuenta: respuesta });
    }
    return this.state.datosCuenta;
  }

  volverDebitoAutomatico = (e) => {
    //history.push('/debitoAutomatico');
    history.push(ConfigService.getPathByName("debitoAutomatico")?.url);
    window.location.reload();
  }

  agregarDebito = (e) => {
    //history.push('/agregarDebito');
    history.push(ConfigService.getPathByName("agregarDebito")?.url);
    window.location.reload();
  }

  descargar = async () => {    
    switch(this.props.rptPaso1.nroModalidad){
      case "8":
        /// aporte
        this.identificador="-";
        this.tipo ="APORTE";
        break;
      case "12":  
        /// solidaridad
        this.identificador="-"
        this.tipo ="SOLIDARIDAD";
        break;
      case "7": 
        /// credito
        this.identificador=this.props.rptPaso1.cuenta_credito;
        this.tipo ="CRÉDITOS";
        break;
      case "10":
        /// tarjeta
        this.identificador=this.props.rptPaso1.TC_tarjeta +" - "+ this.props.rptPaso1.TC_tipo;
        this.montoPorcentaje = "100% de la deuda (Saldo Cierre)";
        if(this.props.rptPaso1.TC_porcentaje === "5")
          this.montoPorcentaje = "5% de la deuda (Pago Mínimo)";
        this.tipo ="TARJETAS";
        break;
      case "11":
        /// ahorro programado
        this.identificador=this.props.rptPaso1.cuenta_credito;
        this.tipo ="AHORRO PROGRAMADO";
        break;
      case "14":
        /// rueda   
        this.identificador=this.props.rptPaso1.cuenta_credito; 
        this.tipo ="RUEDAS";
        break;
    }
    if (this.props.rptPaso1.nroModalidad !== "10"){
      await trackPromise(
        DebitoAutomaticoService.descagarComprobanteAutorizacionDebito(
          "AUTORIZACION DE DEBITO AUTOMATICO",
          this.props.paso2,
          AuthService.getSocio().nombreCompleto,
          AuthService.getSocio().numeroSocio, 
          this.props.rptPaso1.cuenta_debito.split("-")[0],
          this.tipo,
          this.identificador
        )
          .then((response) => {
            var fileURL = URL.createObjectURL(response.data);
            window.open(fileURL, "");
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    }else{
      //// tarjeta
      await trackPromise(
        DebitoAutomaticoService.descagarComprobanteAutorizacionDebitoTarjeta(
          "AUTORIZACION DE DEBITO AUTOMATICO",
          this.props.paso2,
          AuthService.getSocio().nombreCompleto,
          AuthService.getSocio().numeroSocio, 
          this.props.rptPaso1.cuenta_debito.split("-")[0],
          this.tipo,
          this.identificador,
          this.montoPorcentaje
        )
          .then((response) => {
            var fileURL = URL.createObjectURL(response.data);
            window.open(fileURL, "");
          })
          .catch(function (error) {
            console.log(error);
          })
      );
    }  
 
  };

  render() {
    var resultado = [];
    if( this.props.currentStep !== 3)
    return(<span />)
    if (this.props.currentStep === 3) {
     if(this.state.datosCuenta === undefined)
     resultado = this.getDatosPrestamo()
     else
      mensajeExito("La operación se realizó correctamente")
    }
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Selección de Cuenta
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">
                      Datos de Verificación
                          </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <p className="nro-operacion">
             Número de operación: {this.props.paso2} 
            </p>
          </div>
        </div>
        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <DatosSocio />
          </div>
        </div>

        <div className="row justify-content-md-center">
          <div className="col-md-10">
            <div className="row">
              <div className="table-responsive">
                <DataTable
                  noHeader={true}
                  columns={this.getColumn()}
                  data={this.state.datosCuenta}
                  dense={true}
                  noDataComponent="no hay registros para mostrar"
                  responsive={true}
                  noTableHead={true} />
              </div>
            </div>
          </div>
        </div>

        <hr />
        

        <div className="row">
          <div className="col-lg-4 col-md-4">
          <button className="btn btn-cu-quintary btn-consulta" onClick={this.volverDebitoAutomatico}><FontAwesomeIcon icon={faArrowLeft} /> Volver al Listado</button>
          </div>
          <div className="col-lg-4 col-md-4">
          <button className="btn btn-cu-primary btn-consulta" onClick={this.descargar}><FontAwesomeIcon icon={faFilePdf} /> Descargar Comprobante</button>
          </div>
          <div className="col-lg-4 col-md-4">
          <button
              className="btn btn-cu-secundary"
              onClick={this.agregarDebito}> <FontAwesomeIcon icon={faArrowUp} /> Ir al Inicio
            </button>
          </div>
        
        </div>
      </div>
    );
  }
}